<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'MemberGetVo' : 'MemberAddVo'"
            :data="member" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateMember"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateMemberLoading"
          />
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'Member',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      tmpMember: {},
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      updateMemberLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      member: state => state.member.member,
    }),
  },
  methods: {
    ...mapActions({
      getMember: 'member/getMember',
      addMember: 'member/addMember',
      updateMember: 'member/updateMember',
    }),
    ...mapMutations({
      setMember: 'member/setMember',
    }),
    goBack() {
      this.$router.push({path: '/member'})
    },
    onFormChange (data) {
      this.tmpMember = {...data}
    },
    onAddOrUpdateMember () {
      if (this.tmpMember.id) {
        this.updateMemberLoading = true
        this.updateMember(this.tmpMember)
          .then(() => {
            this.updateMemberLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateMemberLoading = false
          })
      } else {
        this.updateMemberLoading = true
        this.addMember(this.tmpMember)
          .then(() => {
            this.updateMemberLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateMemberLoading = false
          })
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getMember(this.$route.params.id).then(() => {
        this.tmpMember = this.member
      })
    }
  },
  destroyed() {
    this.setMember({})
  }
}
</script>
